import React from 'react';
const scores = {
  sentiment: 8,
  deal: 9,
  callReview: 8
};
const overallScore = Math.round((scores.sentiment + scores.deal + scores.callReview) / 3 * 10) / 10;
function getScoreColor(score: number) {
  if (score <= 3) return 'bg-red-500';
  if (score <= 6) return 'bg-yellow-500';
  return 'bg-green-500';
}
export function PrintReport() {
  const today = new Date().toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
  return <div className="bg-white text-black p-8 max-w-4xl mx-auto font-sans text-sm print:p-0 print:max-w-none" data-id="element-196">
      {/* Header */}
      <div className="border-b-2 border-crimson pb-6 mb-8" data-id="element-197">
        <div className="flex justify-between items-end mb-6" data-id="element-198">
          <div data-id="element-199">
            <h1 className="text-3xl font-serif text-navy font-bold mb-1" data-id="element-200">
              NMHL
            </h1>
            <p className="text-xs text-gray-500 uppercase tracking-widest" data-id="element-201">
              National Mortgage Home Loans
            </p>
          </div>
          <div className="text-right" data-id="element-202">
            <h2 className="text-xl font-serif text-navy" data-id="element-203">
              Call Analysis Report
            </h2>
            <p className="text-gray-500" data-id="element-204">{today}</p>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4 text-sm bg-gray-50 p-4 rounded border border-gray-200" data-id="element-205">
          <div data-id="element-206">
            <span className="font-semibold text-gray-600 w-24 inline-block" data-id="element-207">
              Borrower:
            </span>{' '}
            Paul Rutherford
          </div>
          <div data-id="element-208">
            <span className="font-semibold text-gray-600 w-24 inline-block" data-id="element-209">
              Loan Officer:
            </span>{' '}
            Agent
          </div>
          <div data-id="element-210">
            <span className="font-semibold text-gray-600 w-24 inline-block" data-id="element-211">
              Lead Status:
            </span>{' '}
            Demo Requested
          </div>
          <div data-id="element-212">
            <span className="font-semibold text-gray-600 w-24 inline-block" data-id="element-213">
              Loan Amount:
            </span>{' '}
            $N/A
          </div>
        </div>
      </div>

      {/* Key Scores Summary */}
      <div className="mb-8 print-break-inside-avoid" data-id="element-214">
        <h3 className="text-lg font-serif text-navy border-b border-gray-200 pb-2 mb-4" data-id="element-215">
          Executive Summary
        </h3>
        <div className="flex gap-8" data-id="element-216">
          <div className="flex items-center gap-2" data-id="element-217">
            <span className="font-semibold" data-id="element-218">Overall:</span>
            <div className={`w-3 h-3 rounded-full ${getScoreColor(overallScore)}`} data-id="element-219" />
            <span data-id="element-220">{overallScore}/10</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-221">
            <span className="font-semibold" data-id="element-222">Sentiment:</span>
            <div className={`w-3 h-3 rounded-full ${getScoreColor(scores.sentiment)}`} data-id="element-223" />
            <span data-id="element-224">{scores.sentiment}/10</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-225">
            <span className="font-semibold" data-id="element-226">Deal Possibilities:</span>
            <div className={`w-3 h-3 rounded-full ${getScoreColor(scores.deal)}`} data-id="element-227" />
            <span data-id="element-228">{scores.deal}/10</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-229">
            <span className="font-semibold" data-id="element-230">Call Review:</span>
            <div className={`w-3 h-3 rounded-full ${getScoreColor(scores.callReview)}`} data-id="element-231" />
            <span data-id="element-232">{scores.callReview}/10</span>
          </div>
        </div>
      </div>

      {/* Detailed Sections */}
      <div className="space-y-8" data-id="element-233">
        <div className="print-break-inside-avoid" data-id="element-234">
          <h3 className="text-lg font-serif text-navy border-b border-gray-200 pb-2 mb-3" data-id="element-235">
            Sentiment Analysis
          </h3>
          <p className="text-gray-800 leading-relaxed" data-id="element-236">
            The conversation maintained a positive tone throughout, with both
            parties engaging constructively. The client expressed gratitude and
            willingness to proceed, indicating a positive sentiment.
          </p>
        </div>

        <div className="print-break-inside-avoid" data-id="element-237">
          <h3 className="text-lg font-serif text-navy border-b border-gray-200 pb-2 mb-3" data-id="element-238">
            Deal Possibilities
          </h3>
          <p className="text-gray-800 leading-relaxed mb-2" data-id="element-239">
            The client is interested in taking cash out and has a clear purpose
            for the funds. The agent provided suitable options, and the client
            was receptive to the HELOC option. The client's good credit score
            and low first mortgage rate further enhance the likelihood of deal
            closure.
          </p>
          <ul className="list-disc pl-5 text-gray-800 space-y-1" data-id="element-240">
            <li data-id="element-241">HELOC with up to 90% LTV</li>
            <li data-id="element-242">Cash-out refinance with up to 80% LTV</li>
          </ul>
        </div>

        <div className="print-break-inside-avoid" data-id="element-243">
          <h3 className="text-lg font-serif text-navy border-b border-gray-200 pb-2 mb-3" data-id="element-244">
            Call Review
          </h3>
          <p className="text-gray-800 leading-relaxed mb-4" data-id="element-245">
            The call was focused on discussing options for taking cash out of
            the client's home. The agent provided information on HELOC and
            cash-out refinance options, and the client expressed interest in
            proceeding with the HELOC option.
          </p>
          <table className="w-full text-left border-collapse" data-id="element-246">
            <tbody data-id="element-247">
              <tr className="border-b border-gray-100" data-id="element-248">
                <th className="py-2 font-semibold text-gray-600 w-1/3" data-id="element-249">
                  Call Reception Score
                </th>
                <td className="py-2" data-id="element-250">9/10</td>
              </tr>
              <tr className="border-b border-gray-100" data-id="element-251">
                <th className="py-2 font-semibold text-gray-600 w-1/3" data-id="element-252">
                  Loan Options Requested
                </th>
                <td className="py-2" data-id="element-253">HELOC with interest-only option</td>
              </tr>
              <tr className="border-b border-gray-100" data-id="element-254">
                <th className="py-2 font-semibold text-gray-600 w-1/3" data-id="element-255">
                  Loan Options Pitched
                </th>
                <td className="py-2" data-id="element-256">HELOC, Cash-out refinance</td>
              </tr>
              <tr className="border-b border-gray-100" data-id="element-257">
                <th className="py-2 font-semibold text-gray-600 w-1/3" data-id="element-258">
                  Client Objections
                </th>
                <td className="py-2" data-id="element-259">
                  Client was concerned about the lack of interest-only option
                  for HELOC.
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="print-break-inside-avoid" data-id="element-260">
          <h3 className="text-lg font-serif text-navy border-b border-gray-200 pb-2 mb-3" data-id="element-261">
            Behavior Analysis
          </h3>
          <table className="w-full text-left border-collapse border border-gray-200" data-id="element-262">
            <thead data-id="element-263">
              <tr className="bg-gray-50 border-b border-gray-200" data-id="element-264">
                <th className="py-2 px-3 font-semibold text-gray-600" data-id="element-265">
                  Category
                </th>
                <th className="py-2 px-3 font-semibold text-gray-600 w-24 text-center" data-id="element-266">
                  Agent
                </th>
                <th className="py-2 px-3 font-semibold text-gray-600 w-24 text-center" data-id="element-267">
                  Client
                </th>
              </tr>
            </thead>
            <tbody data-id="element-268">
              <tr className="border-b border-gray-200" data-id="element-269">
                <td className="py-2 px-3" data-id="element-270">Enthusiasm</td>
                <td className="py-2 px-3 text-center" data-id="element-271">8</td>
                <td className="py-2 px-3 text-center" data-id="element-272">7</td>
              </tr>
              <tr className="border-b border-gray-200" data-id="element-273">
                <td className="py-2 px-3" data-id="element-274">Hesitation</td>
                <td className="py-2 px-3 text-center" data-id="element-275">3</td>
                <td className="py-2 px-3 text-center" data-id="element-276">4</td>
              </tr>
              <tr className="border-b border-gray-200" data-id="element-277">
                <td className="py-2 px-3" data-id="element-278">Confidence</td>
                <td className="py-2 px-3 text-center" data-id="element-279">8</td>
                <td className="py-2 px-3 text-center" data-id="element-280">8</td>
              </tr>
              <tr className="border-b border-gray-200" data-id="element-281">
                <td className="py-2 px-3" data-id="element-282">Persuasion</td>
                <td className="py-2 px-3 text-center" data-id="element-283">7</td>
                <td className="py-2 px-3 text-center text-gray-400" data-id="element-284">N/A</td>
              </tr>
              <tr className="border-b border-gray-200" data-id="element-285">
                <td className="py-2 px-3" data-id="element-286">Rapport</td>
                <td className="py-2 px-3 text-center" data-id="element-287">8</td>
                <td className="py-2 px-3 text-center text-gray-400" data-id="element-288">N/A</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="print-break-inside-avoid" data-id="element-289">
          <h3 className="text-lg font-serif text-navy border-b border-gray-200 pb-2 mb-3" data-id="element-290">
            Missed Items
          </h3>
          <ul className="space-y-3" data-id="element-291">
            <li className="flex gap-3" data-id="element-292">
              <span className="text-red-600 font-bold mt-0.5" data-id="element-293">!</span>
              <div data-id="element-294">
                <span className="font-semibold block" data-id="element-295">Concrete Terms</span>
                <span className="text-gray-700" data-id="element-296">
                  Discuss concrete terms and conditions relevant to debt
                  consolidation.
                </span>
              </div>
            </li>
            <li className="flex gap-3" data-id="element-297">
              <span className="text-red-600 font-bold mt-0.5" data-id="element-298">!</span>
              <div data-id="element-299">
                <span className="font-semibold block" data-id="element-300">Full Application</span>
                <span className="text-gray-700" data-id="element-301">
                  Avoid disqualifying the client prior to taking a full
                  application.
                </span>
              </div>
            </li>
            <li className="flex gap-3" data-id="element-302">
              <span className="text-red-600 font-bold mt-0.5" data-id="element-303">!</span>
              <div data-id="element-304">
                <span className="font-semibold block" data-id="element-305">
                  Thorough Financial Assessment
                </span>
                <span className="text-gray-700" data-id="element-306">
                  Collect and assess the customer's financial information
                  thoroughly.
                </span>
              </div>
            </li>
          </ul>
        </div>

        <div className="print-break-inside-avoid" data-id="element-307">
          <h3 className="text-lg font-serif text-navy border-b border-gray-200 pb-2 mb-3" data-id="element-308">
            Action Items & Follow Up
          </h3>
          <p className="font-semibold mb-2" data-id="element-309">
            Suggested Follow Up Date: 02/24/2025
          </p>
          <ul className="space-y-2" data-id="element-310">
            <li className="flex items-start gap-2" data-id="element-311">
              <span className="text-gray-400 mt-0.5" data-id="element-312">☐</span> Send the client a
              link to the online portal.
            </li>
            <li className="flex items-start gap-2" data-id="element-313">
              <span className="text-gray-400 mt-0.5" data-id="element-314">☐</span> Follow up with the
              client after portal completion.
            </li>
            <li className="flex items-start gap-2" data-id="element-315">
              <span className="text-gray-400 mt-0.5" data-id="element-316">☐</span> Review client's
              credit and financial information.
            </li>
            <li className="flex items-start gap-2" data-id="element-317">
              <span className="text-gray-400 mt-0.5" data-id="element-318">☐</span> Send a follow-up
              email with portal link.
            </li>
            <li className="flex items-start gap-2" data-id="element-319">
              <span className="text-gray-400 mt-0.5" data-id="element-320">☐</span> Call the client to
              discuss portal completion.
            </li>
            <li className="flex items-start gap-2" data-id="element-321">
              <span className="text-gray-400 mt-0.5" data-id="element-322">☐</span> Schedule a call to
              review loan options.
            </li>
          </ul>
        </div>
      </div>

      {/* Footer */}
      <div className="mt-12 pt-4 border-t border-gray-200 text-center text-xs text-gray-400 print:fixed print:bottom-4 print:w-full print:border-none print:mt-0" data-id="element-323">
        Confidential — NMHL Internal Use Only
      </div>
    </div>;
}